import React from 'react';

import { Link } from "gatsby"

import {
    container,
    active as activeStyle,
    menuItem as menuItemStyle
} from "./NavbarMenu.module.css"

const NavbarMenu = () => {
  return (
    <div className={container}>
        <Link to='/' className={menuItemStyle} activeClassName={activeStyle}>Home</Link> 
        <Link to='/api-reference/' className={menuItemStyle} partiallyActive={true} activeClassName={activeStyle}>API Reference</Link> 
        <Link to='/tutorials/' className={menuItemStyle} partiallyActive={true} activeClassName={activeStyle}>Tutorials</Link> 
        <Link to='/release/' className={menuItemStyle} partiallyActive={true} activeClassName={activeStyle}>Release Notes</Link>  
    </div>
  );
};

export default NavbarMenu;